// Video boyut düzeltmesi ve kontrol butonları
var style = document.createElement('style');
style.innerHTML = `
  deferred-media video,
  deferred-media {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    pointer-events: auto !important;
  }
  .product-media-container--video {
    pointer-events: none !important;
  }
  .product-media-container--video deferred-media,
  .product-media-container--video video,
  .product-media-container--video button {
    pointer-events: auto !important;
  }
`;
document.head.appendChild(style);

// Video muted property'sini override et
function forceUnmute(video) {
  Object.defineProperty(video, 'muted', {
    get: function() { return false; },
    set: function() { return false; },
    configurable: true
  });
  video.volume = 1;
}

// MutationObserver ile yeni eklenen videoları yakala
var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeName === 'VIDEO') {
        forceUnmute(node);
      }
      if (node.querySelectorAll) {
        node.querySelectorAll('video').forEach(forceUnmute);
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  observer.observe(document.body, { childList: true, subtree: true });
  document.querySelectorAll('video').forEach(forceUnmute);
});
// Ürün sayfası video kontrol düzeltmesi
document.addEventListener('DOMContentLoaded', function() {
  function fixVideoControls() {
    document.querySelectorAll('deferred-media').forEach(function(dm) {
      // Tüm child elementlerin pointer-events'ini kontrol et
      var allChildren = dm.querySelectorAll('*');
      allChildren.forEach(function(el) {
        if (el.tagName !== 'VIDEO' && el.tagName !== 'BUTTON') {
          el.style.pointerEvents = 'none';
        }
      });
      var video = dm.querySelector('video');
      if (video) {
        video.style.pointerEvents = 'auto';
        video.controls = true;
      }
    });
  }

  // Sayfa yüklenince ve DOM değişince çalıştır
  fixVideoControls();
  var observer = new MutationObserver(fixVideoControls);
  observer.observe(document.body, { childList: true, subtree: true });
});
// Ürün sayfası video overlay düzeltmesi
document.addEventListener('DOMContentLoaded', function() {
  function fixCursor() {
    document.querySelectorAll('.product-media-container--video *').forEach(function(el) {
      if (el.tagName !== 'VIDEO' && el.tagName !== 'BUTTON' && el.tagName !== 'DEFERRED-MEDIA') {
        var rect = el.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) {
          el.style.pointerEvents = 'none';
        }
      }
    });
    document.querySelectorAll('.product-media-container--video video, .product-media-container--video button').forEach(function(el) {
      el.style.pointerEvents = 'auto';
      el.style.cursor = 'pointer';
    });
  }

  fixCursor();
  var observer = new MutationObserver(fixCursor);
  observer.observe(document.body, { childList: true, subtree: true });
});
